import { useCallback, useState } from 'react';
import {
  BugSynthesisFilters,
  BugSynthesisResult,
  generateBugSynthesis,
} from '../services/bugSynthesisService';

interface UseBugSynthesisReturn {
  result: BugSynthesisResult | null;
  loading: boolean;
  error: string | null;
  generate: (filters: BugSynthesisFilters) => Promise<void>;
}

export function useBugSynthesis(): UseBugSynthesisReturn {
  const [result, setResult] = useState<BugSynthesisResult | null>(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const generate = useCallback(async (filters: BugSynthesisFilters) => {
    setLoading(true);
    setError(null);
    try {
      const data = await generateBugSynthesis(filters);
      setResult(data);
    } catch (err: unknown) {
      const message = err instanceof Error ? err.message : 'Failed to generate synthesis';
      setError(message);
    } finally {
      setLoading(false);
    }
  }, []);

  return { result, loading, error, generate };
}
